export const EntityTypeEnum = Object.freeze({
  SUPPLIER: "SUPPLIER",
  CUSTOMER: "CUSTOMER",
  OUTLET: "OUTLET",
});
